// Modules
import { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { Toaster, toast } from "react-hot-toast";
import { motion } from "framer-motion";
import { AuthContext } from "../../../../Context/AuthContext";
// Components
import Input from "../../../Common/Input/Input";
// Styles
import Styles from "./Styles/Login.module.css";
// Images
import logoImage from "../../../../Assets/Images/logo.png";
import closeImage from "../../../../Assets/Icons/close.png";
import { handleLogin } from "../../../../Services/authService";

const Login = () => {
  const history = useHistory();
  const { login, isLoggedIn } = useContext(AuthContext);
  if (isLoggedIn) {
    history.replace("/");
    toast.error("!شما قبلا وارد شده اید");
  }
  const [account, setAccount] = useState({
    username: "",
    password: "",
  });

  const ValidationSchema = Yup.object().shape({
    username: Yup.string()
      .required("لطفا ایمیل یا شماره تماس خود را وارد کنید")
      .test(
        "input-validation",
        "فرمت شماره تماس یا ایمیل نادرست میباشد",
        function (value) {
          return (
            Yup.string()
              .matches(/^09\d{9}$/, "لطفا شماره تلفن را با فرمت 09 وارد کنید")
              .isValidSync(value) ||
            Yup.string().email("فرمت ایمیل صحیح نیست").isValidSync(value)
          );
        }
      ),
    password: Yup.string()
      .required("لطفا رمز عبور خود را وارد کنید")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "رمز عبور باید حداقل ۸ کاراکتر شامل حروف و اعداد باشد"
      ),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await ValidationSchema.validate(account, {
        abortEarly: false,
      });
      toast.promise(handleLogin(account), {
        loading: "در حال ارسال اطلاعات . . .",
        success: (res) => {
          login(res.data.token);
          history.replace("/");
          window.location.reload();
          return "با موفقیت وارد شدید";
        },
        error: (e) => e.response.data.message,
      });
    } catch (ex) {
      ex.errors.map((i) => toast.error(i));
    }
  };

  const handleChange = ({ currentTarget: input }) => {
    const copyAccount = { ...account };
    copyAccount[input.name] = input.value;
    setAccount(copyAccount);
  };

  return (
    <div className={Styles.container}>
      <Toaster
        toastOptions={{
          duration: 2000,
          style: {
            background: "#363636",
            color: "#fff",
          },
        }}
      />
      <motion.div
        initial={{ x: -1000 }}
        animate={{ x: 0 }}
        exit={{ x: -1000 }}
        transition={{ duration: 0.8 }}
        className={Styles.loginContainer}
      >
        <div className={Styles.flexContainer}>
          <Link to="/" className={Styles.closePage}>
            <img src={closeImage} alt="" />
          </Link>
          <form onSubmit={handleSubmit} className={Styles.innerContainer}>
            <h2>ورود</h2>
            <div className={Styles.register}>
              <Link to="/users/register">حساب کاربری ندارم</Link>
            </div>
            <div className={Styles.inputContainer}>
              <Input
                name="username"
                handleChange={handleChange}
                value={account.username}
                autoFocus={true}
                placeholder="ایمیل یا شماره تماس"
                type="text"
              />
              <Input
                name="password"
                handleChange={handleChange}
                value={account.password}
                autoFocus={false}
                placeholder="رمز عبور"
                type="password"
              />
              <button type="submit">تایید</button>
            </div>
            <div className={Styles.forgetContainer}>
              {/* <Link to="/users/otp-login">ورود با رمز یکبار مصرف</Link> */}
              <Link to="/users/forget-password">فراموشی رمز عبور</Link>
            </div>
          </form>
        </div>
      </motion.div>
      <motion.div
        initial={{ x: 1000 }}
        animate={{ x: 0 }}
        exit={{ x: 1000 }}
        transition={{ duration: 0.8 }}
        className={Styles.logoContainer}
      >
        <img src={logoImage} alt="" />
      </motion.div>
    </div>
  );
};

export default Login;
